import gql from 'graphql-tag';

export const ADVERTISEMENT_SCREEN_CONFIG_FRAGMENT = gql`
    fragment AdvertisementScreenConfigFragment on AdvertisementScreenConfig {
        _id
        imageUrls
    }
`;
